import router from '@/router'

const getNextFromPanels = async (getters, dispatch) => {
  const currentTrack = getters['v4/track/current'];
  let routeSuffix = 'end';

  const panel = await dispatch('v4/panel/next', {}, { root: true });

  if (panel.name) {
    routeSuffix = panel.name;
  }

  return `/track/${currentTrack.id}/${routeSuffix}`;
}

const getNextFromPreferences = async (getters, dispatch) => {
  let next;

  const locations = getters['v4/location/rootLocations']
  const hasLocations = locations.length > 0

  if (hasLocations) {
    const shouldSelectLocations = !getters['v4/location/selectionsComplete'];

    if (shouldSelectLocations) {
      next = '/location'
    }
  }

  if (!next) {
    const preference = await dispatch('v4/preference/next', {}, { root: true });

    next = preference.name ? `/preference/${preference.name}` : '/track';
  }

  return next;
}

export default {

  async reset({ commit }) {
    commit('reset')
  },

  async previous({ getters, rootGetters }, payload) {
    router.go(-1)
  },

  async to({ }, payload) {
    router.push(payload).catch(error => {
      if (error.name != "NavigationDuplicated") {
        throw error
      }
    })
  },

  async toTrackPanel({ rootGetters }, payload) {
    let track = rootGetters['v4/track/current']
    rootGetters.to({ path: `/track/${track.id}/${payload}` }).catch(error => {
      if (error.name != "NavigationDuplicated") {
        throw error
      }
    })
  },

  async next({ state, getters, rootState, rootGetters, dispatch }) {
    router.push(await dispatch('nextLink')).catch(error => {
      if (error.name != "NavigationDuplicated") {
        throw error
      }
    })
  },

  async nextLink({ state, getters, rootState, rootGetters, dispatch }) {
    let next

    switch (rootState.route.name) {
      case 'Start':
        if (rootState.v4.language.source !== 'user') {
          next = `/language/`;
        } else {
          next = await getNextFromPreferences(rootGetters, dispatch);
        }
        break;
      case 'Language':
        next = await getNextFromPreferences(rootGetters, dispatch);
        break;
      case 'Location':
        next = await getNextFromPreferences(rootGetters, dispatch);
        break;
      case 'Preference':
        next = await getNextFromPreferences(rootGetters, dispatch);
        break;
      case 'Summary':
        next = '/track';
        if (rootState.route.meta.collection !== 'preference') {
          next = await getNextFromPanels(rootGetters, dispatch);
        }
        break;
      default:
        next = await getNextFromPanels(rootGetters, dispatch);
        break;
    }

    return next;
  },
}
